module.exports = __webpack_public_path__ + "static/media/rnaapp_111.f2b82e61.ico";